var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGhana(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_6523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 13.4679 0.264047 14.8739 0.746391 16.1739L12 16.6957L23.2536 16.1739C23.736 14.8739 24 13.4679 24 12C24 10.5322 23.736 9.1261 23.2536 7.82612L12 7.30435L0.746391 7.82607C0.264047 9.1261 0 10.5322 0 12H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0C6.84043 0 2.44191 3.2565 0.746399 7.82611H23.2537C21.5581 3.2565 17.1596 0 12 0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2536 16.1739H0.746399C2.44191 20.7435 6.84043 24 12 24C17.1596 24 21.5581 20.7435 23.2536 16.1739Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 7.82611L13.0358 11.0145H16.3887L13.6764 12.9853L14.7123 16.1739L11.9999 14.2033L9.28747 16.1739L10.3236 12.9853L7.61127 11.0145H10.964L11.9999 7.82611Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_6523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhana);
export default __webpack_public_path__ + "static/media/ghana.2e1f2db411f1ec37ef824d7a9215b362.svg";
export { ForwardRef as ReactComponent };